// Journal notes on a dark paper (Jade, 2026-10-18). A note can now be Black, so
// its text has to turn light; everything else in a note is written for light
// paper. The writing area, list cards and exports add `note-ink-light` (see
// theme/darkModeCss.js) when the note's own background is dark.

export const NOTE_BLACK = "#111111";

const luminance = (hex) => {
  const h = hex.replace("#", "");
  const full = h.length === 3 ? h.split("").map(c => c + c).join("") : h.slice(0, 6);
  const [r, g, b] = [0, 2, 4].map(i => {
    const v = parseInt(full.slice(i, i + 2), 16) / 255;
    return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

// True when a note background (a colour or a gradient) is dark enough that
// dark text would be hard to read on it. Gradients average their colours.
// Photos ("url(...)") are drawn on white paper, so they count as light.
export function isDarkNoteBg(bg) {
  if (typeof bg !== "string" || !bg || bg.includes("url(")) return false;
  const hexes = bg.match(/#[0-9a-fA-F]{6}\b|#[0-9a-fA-F]{3}\b/g);
  if (!hexes) return false;
  const avg = hexes.reduce((s, h) => s + luminance(h), 0) / hexes.length;
  return avg < 0.18;
}

// A note's own background, as the editor paints it.
export const noteBackground = (note) => (note && (note.noteBg || note.color)) || "#fff7f9";
